<template>
  <RestaurantRequestsForm :typeEndPoint="'restauranCateforiesForm'" :dataParams="{}"/>
</template>
<script>
import RestaurantRequestsForm from '@/components/modules/restaurant/categories/form'
export default {
  name: 'RestaurantRequestsCreate',
  components: {
    RestaurantRequestsForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/categories/create.vue